import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CardActionArea, Stack, Typography } from '@mui/material';

import { GoBackButton, SearchBar } from '@app/components';
import useResponsive from '@app/hooks/use-responsive';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { useRequestState } from '@app/hooks';
import { Strings } from '@app/constants';
import { getSearchedItems } from '../selectors';
import { searchItems } from '../slice';

const SearchScreen = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const isMobile = useResponsive('down', 'md');
  const isTab = useResponsive('down', 'lg');

  const [searchText, setSearchText] = useState('');

  const { data } = useRequestState({
    stateSelector: getSearchedItems,
    errorShown: true,
  });

  const onChangeText = (event: any) => {
    const searchedString = event?.target?.value.trim();
    if (searchedString) {
      setSearchText(event?.target?.value);
      dispatch(searchItems(searchedString));
    }
  };

  const highlightText = (text: string, highlight: string) => {
    if (!highlight) return <Typography color="textDisabled">{text}</Typography>;
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

    return (
      <Typography color="textDisabled">
        {parts.map((part, index) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span key={index} style={{ color: 'black' }}>
              {part}
            </span>
          ) : (
            part
          )
        )}
      </Typography>
    );
  };

  const renderItem = (item: any, index: number) => {
    return (
      <CardActionArea
        key={index}
        onClick={() => navigation(PATH_DASHBOARD.recipeDetailsScreen, { state: item })}
        sx={{
          width: isMobile ? '100%' : isTab ? 400 : 550,
          borderRadius: 1,
        }}
      >
        <Stack sx={styles.searchedCard}>
          <img src={item.image} style={styles.image} />
          {highlightText(item.label, searchText)}
        </Stack>
      </CardActionArea>
    );
  };

  return (
    <Stack>
      <Stack sx={styles.searchContainer}>
        <GoBackButton sx={{ height: '70%' }} />
        <SearchBar
          placeholder={Strings.field.searchDishes}
          fullWidth
          onChange={onChangeText}
          sx={{ width: '90%' }}
        />
      </Stack>
      <Stack
        style={{
          flexDirection: 'row',
          gap: 15,
          flexWrap: 'wrap',
          marginTop: 10,
          alignSelf: 'center',
          width: isMobile ? '' : '91%',
        }}
      >
        {data?.map((item: any, index: any) => renderItem(item, index))}
      </Stack>
    </Stack>
  );
};

const styles = {
  searchContainer: { flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' },
  searchedCard: {
    height: 80,
    width: '100%',
    bgcolor: 'white',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: '320px',
    p: 2,
    borderRadius: 1,
  },
  image: { height: 50, width: 50, borderRadius: '50px', marginRight: 20 },
};
export { SearchScreen };
